var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initMainArticle = /* @__PURE__ */ __name(($el) => {
  var _a, _b, _c;
  const state = window.Alpine.reactive({
    loading: false,
    count: (_b = (_a = $el.querySelector("[data-next-url]")) == null ? void 0 : _a.children) == null ? void 0 : _b.length,
    next_url: (_c = $el.querySelector("[data-next-url]")) == null ? void 0 : _c.getAttribute("data-next-url")
  });
  const loadNextPage = /* @__PURE__ */ __name(async (container = $el.querySelector(`[data-next-url]`), paginationContainer = $el.querySelector(`[data-pagination][x-ref="pagination"]`)) => {
    var _a2;
    if (!state.next_url || state.loading) return;
    state.loading = true;
    const html = await fetch(state.next_url).then((res) => res.text());
    const newDocument = document.createElement("div");
    newDocument.innerHTML = html;
    const section = newDocument.querySelector(`[data-style-id="${$el.getAttribute("data-style-id")}"]`);
    const newContent = section.querySelector(`[data-next-url][x-ref="${container == null ? void 0 : container.getAttribute("x-ref")}"]`);
    state.next_url = newContent == null ? void 0 : newContent.getAttribute("data-next-url");
    const newPagination = section.querySelector(`[data-pagination][x-ref="pagination"]`);
    if (newContent) {
      container.append(...newContent.children);
      state.count = (_a2 = container == null ? void 0 : container.children) == null ? void 0 : _a2.length;
    }
    if (paginationContainer && newPagination) {
      paginationContainer.innerHTML = newPagination.innerHTML;
    }
    state.loading = false;
  }, "loadNextPage");
  return {
    main_article: {
      state,
      loadNextPage
    }
  };
}, "initMainArticle");
window._sections["initMainArticle"] = initMainArticle;
